// @flow

import * as React from 'react';

import type { DecoratedProduct } from '@gandi/cart';
import { Fqdn } from '@gandi/ui';

import FqdnBadge from 'src/DomainCreate/components/DomainList/FqdnCell/FqdnBadge';

type Props = { product: DecoratedProduct };

export function DomainLabel({ product }: Props): React.MixedElement {
  return (
    <>
      <Fqdn>{product.label || ''}</Fqdn>
      {product.isPremium && (
        <>
          <FqdnBadge type="premium" />{' '}
        </>
      )}
    </>
  );
}
